// change the state inside the store, setter
import Vue from "vue";

const moduleMutations = {
  setEvents(state, { roomId, events }) {
    Vue.set(state.events, roomId, events);
  }
};

export default moduleMutations;
